import { makeStyles } from '@bayon/commons';

export const useStyles = makeStyles({
  container: {
    padding: '10px 0px',
    overflow: 'auto',
    flex: '1',
  },
});
